export default {"src":"/_next/static/media/toothBrush_40.8b440972.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};